<template>
    <div>
      <CCardHeader style="    margin-top: 10px; text-align: end !important;" >
        <div  class="flexColumn">
          
          <JsonCSV
                v-if="tableData.length"
                color="primary"
                class="btn btn-default mb-2 clr"
                :data="tableData"
                name="Tournament users.csv"
                style="
                  background: aquamarine !important;
                  color: darkcyan !important;
                  width: 30%;
                  
                "
              >
                Download CSV</JsonCSV
              >
        </div>
      </CCardHeader>
      <CCard style="margin-top: 20px">
        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            column-filter
            table-filter
            items-per-page-select
            :items-per-page="10"
            hover
            sorter
            pagination
            responsive
          >
          <template #status="{ item }">
          <span v-if="item.status == 'success'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-success ml-1"
                >
                Correct
                </a></span
              >
              <span v-if="item.status == 'wrong'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-danger ml-1"
                >
                  Wrong
                </a></span
              >
              <span v-if="item.status == 'cancel'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  Cancelled
                </a></span
              >
          </template>
            <template #icon="{ item }">
              <td>
                <img :Src="item.icon" class="icon" />
              </td>
            </template>
            <!-- <template #action="{ item }">
              <td>
                <CButton
                  color="success"
                  style="width: 100px"
                  v-if="item.isSettlement"
                  @click="filterdata(item)"
                  >Button</CButton
                >
              </td>
            </template> -->
          </CDataTable>
        </CCardBody>
      </CCard>
    </div>
  </template>
  
  <script>
  import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
  import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
  import firebase from "firebase";
  const db = firebase.firestore();
  import moment from "moment";
  import Swal from "sweetalert2";
  import JsonCSV from "vue-json-csv";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import axios from "axios";
  import { secondaryDatabase } from "./secondary.js";
  export default {
    components: {
      JsonCSV,
      DatePicker,
      VueCtkDateTimePicker,
    },
    data() {
      return {
        tokenName:"",
        tableData: [],
        GameName: "",
        GameId: "",
        options: [],
        value1: [],
        // userdata: [],
        // tableData2: [],
        // tableData3: [],
        fields: [
          {
            label: "created",
            key: "created",
            sortable: true,
          },
        
          {
            label: "Match",
            key: "Match",
            sortable: true,
          },
          {
            label: "Answer",
            key: "Answer",
            sortable: true,
          },{
            label: "Paid Amount",
            key: "Amount",
            sortable: true,
          },
          {
            label: "Winning Amount",
            key: "winningamount",
            sortable: true,
          },
          {
            label: "TokenName",
            key: "tokenName",
            sortable: true,
          },
          {
            label: "status",
            key: "status",
            sortable: true,
          },
          {
            label: "TeamName",
            key: "TeamName",
            sortable: true,
          },
        ],
      };
    },
    watch: {
      value1() {
        console.log("entered");
        var res = new Date(this.value1[1]);
        res.setDate(res.getDate() + 1);
  
        let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
        let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
        console.log("v1", v1);
        console.log("v2", v2);
        secondaryDatabase.collection("gametournamentEntry")
          .where("entrydate", ">=", v1)
          .where("entrydate", "<=", v2)
          .orderBy("entrydate", "desc")
          .get()
          .then((snapshot) => {
            this.tableData = [];
            snapshot.forEach((doc) => {
              // console.log(doc.data());
              this.tableData.push({
                name: doc.data().gameName,
                amount: doc.data().amount,
                email: doc.data().email,
                selectedToken: doc.data().selectedToken,
                tournamentId: doc.data().tournamentId,
                walletAddress: doc.data().walletAddress,
                amount: doc.data().amount,
                tokenName:this.tokenName,
                winningamount:doc.data().winningamount ?doc.data().winningamount:0,
                matchStartTime: moment(
                  doc.data().matchStartTime.seconds * 1000
                ).format("DD-MMM-YYYY, hh:mm a"),
                entrydate: moment(doc.data().entrydate.seconds * 1000).format(
                  "DD-MMM-YYYY, hh:mm a"
                ),
              });
            });
            console.log(" this.tableData.", this.tableData);
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      },
    },
    methods: {
      getGameNames() {
        secondaryDatabase.collection("HTMLGames")
          .where("fixedPayout", "==", false)
          .get()
          .then((snapshot) => {
            this.tableData = [];
            // var i = 0;
  
            snapshot.forEach((doc) => {
              // if (i != 0) {
              this.options.push(doc.id);
              // }
              // i = i + 1;
            });
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      },
      filterdata() {
        console.log(this.GameId);
        console.log(this.GameName);
        let data = {
          gameName: this.GameName,
          tournamentID: this.GameId,
        };
        console.log("data", data);
  
        axios
          .post(
            "https://us-central1-token-geomine.cloudfunctions.net/api/getTournamentLeaderboard",
            data
            // {
            //   headers: {
            //     "Content-Type":
            //       "application/x-www-form-urlencoded; charset=UTF-8",
            //   },
            // }
          )
          .then((snapshot) => {
            this.tableData = [];
            console.log("snapshot", snapshot.data.Result);
            this.tableData = snapshot.data.Result;
            //     this.tableData.push({
            //       email: snapshot.data.email,
            //       point: snapshot.data.point,
  
            //   });
  
            console.log(" this.tableData", this.tableData);
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      },
      getGames(docId) {
        console.log("game",docId);
        // var startOfToday = new Date();
        // startOfToday.setHours(0, 0, 0, 0);
        // var endOfToday = new Date();
        // endOfToday.setHours(23, 59, 59, 999);
  
        secondaryDatabase.collection("bettingpointEntry")
          .where("bettingId", "==", docId)
          // .where("created", ">=", startOfToday)
          // .where("created", "<=", endOfToday)
          // .orderBy("highestScore", "desc")
          .get()
          .then((snapshot) => {
            // this.tableData = [];
            console.log("doc2",snapshot);
            snapshot.forEach((doc) => {
              console.log("doc",doc.data());
              this.tableData.push({
                Match: doc.data().Match,
                Answer: doc.data().answer,
                TeamName: doc.data().email,
                Amount: doc.data().bettingamount,
                status: doc.data().status,
                
                created: moment(doc.data().created.seconds * 1000).format(
                  "DD-MMM-YYYY, hh:mm a"
                ),
                tokenName:this.tokenName,
                winningamount:doc.data().winningamount ?doc.data().winningamount:0,
              });
            });
            console.log(" this.tableData.", this.tableData);
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      },
    },
    created() {
      this.id = this.$route.params.id;
      this.tokenName = this.$route.params.tokenName;
      this.getGames(this.id);
      // this.getGameNames();
    },
  };
  </script>
  
  <style>
  .icon {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }
  </style>
  